import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import { lazy, Suspense } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router'

import { ErrorBoundary } from './components/ErrorBoundary'
import Login from './components/Login'
import PageLoading from './components/PageLoading'
import ProtectedRoute from './components/ProtectedRoute'
import { SignalRProvider } from './providers/SignalRProvider'

// Lazy-loaded page components
const StoryboardProcess = lazy(() => import('./features/storyboard/StoryboardProcessPage'))
const Commercials = lazy(() => import('./features/commercials/Commercials'))
const QueueManagement = lazy(() => import('./features/queue/QueueManagement'))
const Settings = lazy(() => import('./features/settings/Settings'))

// Lazy-loaded layout — will be migrated later
const MainLayout = lazy(() => import('./components/MainLayout'))

function LazyRoute({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoading />}>{children}</Suspense>
    </ErrorBoundary>
  )
}

const authRouter = createBrowserRouter([
  {
    element: (
      <SignalRProvider>
        <MainLayout />
      </SignalRProvider>
    ),
    children: [
      {
        path: '/',
        element: (
          <ProtectedRoute>
            <LazyRoute>
              <Commercials />
            </LazyRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: '/settings',
        element: (
          <ProtectedRoute>
            <LazyRoute>
              <Settings />
            </LazyRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: '/queue-management',
        element: (
          <ProtectedRoute>
            <LazyRoute>
              <QueueManagement />
            </LazyRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: '/commercial/:id',
        element: (
          <ProtectedRoute>
            <LazyRoute>
              <StoryboardProcess />
            </LazyRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: '*',
        element: <div>NOT FOUND</div>,
      },
    ],
  },
])

const unauthRouter = createBrowserRouter([
  {
    element: <MainLayout />,
    children: [
      {
        path: '*',
        element: <Login />,
      },
    ],
  },
])

export default function AppRoutes() {
  return (
    <>
      <AuthenticatedTemplate>
        <Suspense fallback={<PageLoading />}>
          <RouterProvider router={authRouter} />
        </Suspense>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Suspense fallback={<PageLoading />}>
          <RouterProvider router={unauthRouter} />
        </Suspense>
      </UnauthenticatedTemplate>
    </>
  )
}
